import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { deleteSubjectReconciliationMatch } from '../../paymentReconciliationModal/query-api'

interface UseDeleteSubjectReconciliationSuggestionProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useDeleteSubjectReconciliationSuggestion = (props?: UseDeleteSubjectReconciliationSuggestionProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: deleteSuggestion,
    isLoading: isProcessing,
    ...rest
  } = useMutation(deleteSubjectReconciliationMatch, {
    onSuccess,
    onError,
  })

  return { deleteSuggestion, isProcessing, ...rest }
}
